import { loadContent, devValidate } from '@/content/index';
import { takeJob } from '@/systems/missions';
import { initAssets } from '@/assets/assetManager';
import { initSfx, setSound } from '@/audio/sfx';
import { Game } from '@/core/game';
import { UI } from '@/ui/ui';
import { setupTouch, isTouchMode } from '@/ui/touch';
import { setLabelScale } from '@/world/builders';
import { translateStaticDom, isEn } from '@/i18n';

export async function boot() {
  translateStaticDom();
  // v1.2 場景名牌：手機畫面小、英文字母比中文小，都放大一點
  setLabelScale((isTouchMode() ? 1.3 : 1) * (isEn() ? 1.2 : 1));
  await initAssets();
  const content = loadContent();
  void devValidate();
  const canvas = document.getElementById('c') as HTMLCanvasElement;
  const game = new Game(content, canvas);
  const ui = new UI(game);
  game.attachUI(ui);
  setupTouch(game, ui);
  initSfx(); setSound(game.profile.settings.sound);

  const app = document.getElementById('app')!;
  const resize = () => game.stage.resize(app.clientWidth, app.clientHeight);
  addEventListener('resize', resize); resize();

  // 標題畫面背景：用玩家上次的職務起始樓層當預覽
  const role = content.roleById.get(game.profile.roleId ?? '') ?? content.roles[0];
  const floor = content.floorById.get(role.startFloor)!;
  game.stage.loadFloor(floor, floor.spawn, game.profile.flags, false, () => true);
  ui.showStart();

  const loop = () => { requestAnimationFrame(loop); game.update(); };
  loop();
  // v1.4.1 小遊戲在背景先下載（開場畫面出來後 2 秒，不跟遊戲本體搶網路）
  setTimeout(() => void import('@/minigames/registry').then(m => m.preloadGames()), 2000);
  if (import.meta.env.DEV || location.search.includes('debug')) (window as any).__ffg = { game, ui, content, takeJob };
}
